import { getHeaderHeight } from './getHeaderHeight';

export const scrollToElement = $element => {
  let scrollTop = $element.offset().top - getHeaderHeight() - 20;
  if ($('.menu-wrapper.sticky').length === 0) {
    scrollTop = $element.offset().top - 80;
  }
  $('html, body').animate({ scrollTop }, 400);

  const invalidElementContainer = $element.children('.validate.invalid').first();
  if ($(invalidElementContainer).hasClass('validate-select')) {
    const selectSpanElement = $(invalidElementContainer).first().children('.select2.select2-container.select2-container--default');
    const focusElement = $(selectSpanElement).children('.selection').children('.select2-selection.select2-selection--single');
    $(focusElement).focus();
  } else if(invalidElementContainer.hasClass('validate-input')) {
    const inputElement = $(invalidElementContainer).first().children('.field.js-form-element').first();
    $(inputElement).focus();    
  } else if(invalidElementContainer.hasClass('field-checkbox-container')){
    const checkboxElement = $(invalidElementContainer).first().children('.field.js-form-element').first();
    $(checkboxElement).focus();  
  }
};
